import React, { useEffect, useRef } from "react";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import hvacImg1 from "../../Assets/hvac_img_1.png";
import hvacImg2 from "../../Assets/hvac_img_2.png";
import hvacImg3 from "../../Assets/hvac_img_3.png";
import hvacImg4 from "../../Assets/hvac_img_4.png";
import hvacImg5 from "../../Assets/hvac_img_5.png";
import hvacImg6 from "../../Assets/hvac_img_6.png";
import hvacImg7 from "../../Assets/hvac_img_7.png";
import hvacImg8 from "../../Assets/hvac_img_8.png";
// import hvacImg9 from "../../Assets/hvac_img_9.png";
import hvacImg10 from "../../Assets/hvac_img_10.png";
import hvacImg11 from "../../Assets/hvac_img_11.png";
import hvacImg12 from "../../Assets/hvac_img_12.png";
import hvacImg13 from "../../Assets/hvac_img_13.png";

function Importance() {
  const importanceRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -20px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log('Adding animate-in to Importance:', entry.target.className);
          entry.target.classList.add('animate-in');
        } else {
          console.log('Removing animate-in from Importance:', entry.target.className);
          entry.target.classList.remove('animate-in');
        }
      });
    }, observerOptions);

    if (importanceRef.current) {
      observer.observe(importanceRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section ref={importanceRef} className="importance-section scroll-animate">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} className="text-center">
            <div className="importance-image-container">
              <Carousel interval={2000} controls indicators pause="hover" touch>
                {[hvacImg11, hvacImg12, hvacImg13, hvacImg1, hvacImg2,
                  hvacImg3, hvacImg4, hvacImg5, hvacImg6, hvacImg7,
                  hvacImg8, hvacImg10].map((src, index) => (
                    <Carousel.Item key={index}>
                      <img
                        src={src}
                        alt={`유지보수 현장 ${index + 1}`}
                        className="importance-main-image"
                      />
                    </Carousel.Item>
                  ))}
              </Carousel>
            </div>

            <div className="importance-content">
              <h2 className="importance-title">유지 보수의 중요성</h2>

              <div className="importance-item">
                <h3 className="importance-subtitle">에너지 효율성 향상</h3>
                <p className="importance-description">
                  정기적인 점검과 청소를 통해 <br className="mobile-line-break" />시스템이 최적의 효율로 유지됩니다.
                </p>
              </div>

              <div className="importance-item">
                <h3 className="importance-subtitle">비용 절감</h3>
                <p className="importance-description">
                  예방 유지보수를 통해 고장 발생을 미연에 <br className="mobile-line-break" />방지하여 수리비용을 절감할 수 있습니다.
                </p>
              </div>

              <div className="importance-item">
                <h3 className="importance-subtitle">시스템 수명 연장</h3>
                <p className="importance-description">
                  정기적으로 점검하고 수리하여<br className="mobile-line-break" /> HVAC 시스템의 수명이 길어집니다.
                </p>
              </div>

              <div className="importance-detail">
                <p>
                  정기 유지보수를 통해 <strong>HVAC 시스템의<br className="mobile-line-break" /> 안정적인 작동</strong>을 보장하고, <br className="tablet-line-break" /><strong>운영 비용을 절감</strong>할 수 있습니다.<br />
                  이를 통해 고객에게 더 나은 서비스와 <br className="mobile-line-break" />쾌적한 환경을 제공할 수 있습니다.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Importance;



